import { defineComponent as _defineComponent } from 'vue';
import { BButton, BFormGroup, BFormInput } from "bootstrap-vue";
import { computed, ref } from "vue";
import {} from "@/api/remoteFiles";
import localize from "@/utils/localization";
import RDMDestinationSelector from "@/components/Common/RDMDestinationSelector.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ExportRDMForm',
    props: {
        what: { default: "archive" },
        clearInputAfterExport: { type: Boolean, default: false },
        defaultRecordName: { default: "" },
        defaultFilename: { default: "" },
        fileSource: { default: undefined }
    },
    emits: ["export"],
    setup(__props, { emit }) {
        const props = __props;
        const destinationSelector = ref();
        const recordUri = ref("");
        const fileName = ref(props.defaultFilename);
        const isNewRecord = ref(true);
        const canExport = computed(() => Boolean(recordUri.value) && Boolean(fileName.value));
        const nameDescription = computed(() => localize("Give the exported file a name."));
        const namePlaceholder = computed(() => localize("File name"));
        function doExport() {
            emit("export", recordUri.value, fileName.value);
            if (props.clearInputAfterExport) {
                clearInputs();
            }
        }
        function clearInputs() {
            recordUri.value = "";
            fileName.value = "";
            //@ts-ignore incorrect property not found error
            destinationSelector.value?.reset();
        }
        function onRecordSelected(selectedRecordUri) {
            recordUri.value = selectedRecordUri;
        }
        return { __sfc: true, props, emit, destinationSelector, recordUri, fileName, isNewRecord, canExport, nameDescription, namePlaceholder, doExport, clearInputs, onRecordSelected, BButton, BFormGroup, BFormInput, RDMDestinationSelector };
    }
});
